import * as React from "react"
import { useParams, useNavigate } from "react-router-dom"
import { motion } from "motion/react"
import { AppSidebar, type TabType } from "@/components/AppSidebar"
import { DashboardTab } from "@/components/dashboard/DashboardTab"
import { ChatTab } from "@/components/dashboard/ChatTab"
import { ResourcesTab } from "@/components/dashboard/ResourcesTab"
import { PokerTab } from "@/components/dashboard/PokerTab"
import { EventsTab } from "@/components/dashboard/EventsTab"
import { StoreTab } from "@/components/dashboard/StoreTab"
import { LeaderboardTab } from "@/components/dashboard/LeaderboardTab"
import { DealMarquee } from "@/components/dashboard/DealMarquee"
import { RetroBackground } from "@/components/RetroBackground"

const validTabs: TabType[] = [
  "dashboard",
  "chat",
  "resources",
  "poker",
  "store",
  "events",
  "leaderboard",
]

export function Dashboard() {
  const { tab } = useParams<{ tab?: string }>()
  const navigate = useNavigate()

  // Determine active tab from URL, default to "dashboard"
  const activeTab: TabType = validTabs.includes(tab as TabType) ? (tab as TabType) : "dashboard"

  const handleTabChange = (newTab: TabType) => {
    if (newTab === "dashboard") {
      navigate("/dashboard")
    } else {
      navigate(`/dashboard/${newTab}`)
    }
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case "dashboard":
        return <DashboardTab />
      case "chat":
        return <ChatTab />
      case "resources":
        return <ResourcesTab />
      case "poker":
        return <PokerTab />
      case "store":
        return <StoreTab />
      case "leaderboard":
        return <LeaderboardTab />
      case "events":
        return <EventsTab />
      default:
        return <DashboardTab />
    }
  }

  return (
    <div className="min-h-screen relative">
      <RetroBackground />

      <div className="relative z-10 min-h-screen">
        <AppSidebar activeTab={activeTab} onTabChange={handleTabChange}>
          <DealMarquee />
          {activeTab === "chat" || activeTab === "poker" ? (
            <div className="h-[calc(100vh-64px-40px)] md:h-[calc(100vh-40px)] overflow-hidden">
              <motion.div
                key={activeTab}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ type: "spring" as const, bounce: 0.3, duration: 0.4 }}
                className="h-full"
              >
                {renderTabContent()}
              </motion.div>
            </div>
          ) : (
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ type: "spring" as const, bounce: 0.3, duration: 0.4 }}
              className="min-h-screen"
            >
              {renderTabContent()}
            </motion.div>
          )}
        </AppSidebar>
      </div>
    </div>
  )
}
